import type { AuthStatus } from "@codvero/shared";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";
import { authApi } from "@/api/auth.ts";

export const authStatusQuery = queryOptions({
  queryKey: ["auth", "status"],
  queryFn: authApi.status,
  staleTime: 60_000,
  retry: false,
});

export function useAuthStatus() {
  return useQuery(authStatusQuery);
}

/** The product's name here: "Codvero", or "Codvero Lab" on the Lab installation. */
export function useAppName(): string {
  return useAuthStatus().data?.edition === "lab" ? "Codvero Lab" : "Codvero";
}

export function useSetAuthUser() {
  const qc = useQueryClient();
  return (user: AuthStatus["user"]) => qc.setQueryData<AuthStatus>(authStatusQuery.queryKey, (old) => ({ setupRequired: false, googleSignIn: old?.googleSignIn ?? false, singleProject: old?.singleProject ?? false, edition: old?.edition ?? null, user }));
}
